import { z } from 'zod'

export const REVIEW_TYPES = ['GOOGLE', 'YELP', 'FACEBOOK', 'ANGI', 'BBB'] as const
export type ReviewType = (typeof REVIEW_TYPES)[number]
export const ReviewTypeSchema = z.enum(REVIEW_TYPES)
